import React from "react"
import BasicInput from "../../BasicInput/BasicInput"

const DimensionInput = ({
    label,
    feature,
    value,
    onChange,
    values,
    ...props
}) => {
    return (
        <div className="row align-items-center mb-3">
            <div className="col-md-3">
                <label className="form-label fw-medium">{label}</label>
            </div>
            <div className="row col-md-8 m-0 p-0 justify-content-between align-items-center">
                {feature.features?.map((field, index) => {
                    return (
                        <div
                            key={index}
                            className={`col-${index === 0 ? 6 : 6} row m-0 p-0`}
                        >
                            <div
                                className="col-9 d-flex flex-row justify-content-start align-items-center row m-0 p-0"
                                key={field?.slug}
                                style={{ background: "#fff", borderRadius: "8px" }}
                            >
                                <div className="col-8 m-0 p-0">
                                    <BasicInput
                                        key={field.slug}
                                        feature={field}
                                        label={field?.name}
                                        type={field.type}
                                        value={value[field.slug]}
                                        onChange={onChange}
                                        hideLabel={true}
                                        className="pe-0 mb-0"
                                        styling={{
                                            marginBottom: "0px !important"
                                        }}
                                    />
                                </div>
                                <div className="col-4">{values?.unit}</div>
                            </div>
                            {index < feature.features.length - 1 && (
                                <div className="col-md-2 d-flex justify-content-end align-items-center">
                                    ×
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default DimensionInput